import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import api, { errMsg } from "@/lib/api";

const LABELS = {
  due: { tab: "Perlu Dipost Sekarang", what: "semua post yang perlu dipost sekarang" },
  upcoming: { tab: "Akan Datang", what: "semua post terjadual akan datang (termasuk post berulang)" },
  approval: { tab: "Menunggu Admin", what: "semua post yang menunggu kelulusan admin (rekod ini juga hilang dari Sejarah)" },
};

export default function ClearQueueButton({ bucket, count, onCleared }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const label = LABELS[bucket];

  const clear = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.delete("/queue", { params: { bucket } });
      toast.success(`${data.removed_targets} post dipadam dari "${label.tab}"`);
      setOpen(false);
      onCleared();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <>
      <Button variant="ghost" onClick={() => setOpen(true)} disabled={!count} className="border border-red-500/30 text-red-300 hover:bg-red-500/10 hover:text-red-200" data-testid={`queue-clear-${bucket}-btn`}>
        <Trash2 className="mr-2 h-4 w-4" /> Padam semua{count ? ` (${count})` : ""}
      </Button>
      <AlertDialog open={open} onOpenChange={(o) => !busy && setOpen(o)}>
        <AlertDialogContent className="border-border bg-card" data-testid="queue-clear-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Padam semua dalam "{label.tab}"?</AlertDialogTitle>
            <AlertDialogDescription>
              {count} post akan dipadam, iaitu {label.what}. Tindakan ini tidak boleh dibatalkan. Senarai group anda tidak terjejas.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={busy} data-testid="queue-clear-cancel">Batal</AlertDialogCancel>
            <AlertDialogAction onClick={clear} disabled={busy} className="bg-red-600 text-white hover:bg-red-500" data-testid="queue-clear-confirm">
              {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Trash2 className="mr-2 h-4 w-4" />} Ya, padam semua
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
